module.exports = __webpack_public_path__ + "static/step-1-8373787f110cfe9e6bbdc55d195ad65d.svg";